export { default } from './DoughnutChart';
export { default as DoughnutChartCenterLabel } from './DoughnutChartCenterLabel';
